// src/services/distributionCompanyApi.js
//
// Elektrik dağıtım şirketleri API servisi.
//   - getAll()         → tüm aktif şirketler
//   - getByIl(il)      → bir ile yetkili şirketler
//   - create(data)     → admin: yeni şirket
//   - update(id, data) → admin: güncelle
//   - remove(id)       → admin: sil

import API_URL from '../config';

const BASE = `${API_URL}/api/distribution-companies`;

function authHeaders() {
  const token = localStorage.getItem('projabze_token');
  return token
    ? { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
    : { 'Content-Type': 'application/json' };
}

async function extractError(res) {
  try {
    const data = await res.json();
    return data.message || `HTTP ${res.status}`;
  } catch {
    return `HTTP ${res.status}`;
  }
}

/** Tüm aktif dağıtım şirketlerini getirir. */
export async function getAllDistributionCompanies() {
  const res = await fetch(BASE);
  if (!res.ok) throw new Error(await extractError(res));
  const { companies } = await res.json();
  return companies;
}

/**
 * Bir ile yetkili şirket(ler)i getirir.
 * @param {string} il — Türkçe il adı (örn. "Ankara")
 * @returns {Promise<Array>}
 */
export async function getDistributionCompaniesByIl(il) {
  const res = await fetch(`${BASE}?il=${encodeURIComponent(il)}`);
  if (!res.ok) throw new Error(await extractError(res));
  const { companies } = await res.json();
  return companies;
}

/** (Admin) Yeni dağıtım şirketi ekler. */
export async function createDistributionCompany(data) {
  const res = await fetch(BASE, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(await extractError(res));
  const { company } = await res.json();
  return company;
}

/** (Admin) Mevcut şirketi günceller. */
export async function updateDistributionCompany(id, data) {
  const res = await fetch(`${BASE}/${id}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(await extractError(res));
  const { company } = await res.json();
  return company;
}

/** (Admin) Şirketi siler. */
export async function removeDistributionCompany(id) {
  const res = await fetch(`${BASE}/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(await extractError(res));
}
